import { navigationNamespace } from "@/store/modules/navigation";
import { Store } from "vuex";

const patientNamespace = { namespace: "patient" };
export default function(store: Store<any>) {
  // Sync router view changes with other stores
  store.subscribe(mutation => {
    if (mutation.type === "route/ROUTE_CHANGED") {
      store.commit(
        `${navigationNamespace.namespace}/routeHistory`,
        mutation.payload.to
      );
      let room = parseInt(mutation.payload.to.params.room, 10) || null;
      // Keep the patient store always up to date with the current patient id (roomSys)
      store.commit(`${patientNamespace.namespace}/setId`, {
        id: room
      });
    }
  });
}
